import React, { useState } from "react";

// Material-UI Components
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Popover from "@material-ui/core/Popover";

// External Libraries
import classNames from "classnames";

// Helper Functions
import { capitalizeFirstLetter } from "../../../helper";

// Local Stylesheet
import "./RequestDetailedAdvanceFilter.scss";

function RequestDetailedAdvanceFilter({
  id,
  open,
  anchorEl,
  onClose,
  state,
  handleChange,
}) {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={() => onClose()}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <main className="new-design-v1 request-details-advance-search-container">
        <div className="filter-header">
          <p className="title">Filters</p>
        </div>
        <div>
          <RequestDetailsAdvanceFilterTabs
            state={state}
            handleChange={handleChange}
          />
        </div>
        <div className="filter-footer">
          <div
            className="clear-all"
            onClick={() => handleChange("clearAllFilters")}
          >
            Clear all
          </div>
          <div className="action-buttons">
            <button
              className="secondary-button"
              onClick={() => onClose()}
              style={{ maxHeight: "40px" }}
            >
              Cancel
            </button>
            <button
              className="primary-button"
              onClick={() => onClose(true)}
              style={{ maxHeight: "40px" }}
            >
              Apply
            </button>
          </div>
        </div>
      </main>
    </Popover>
  );
}

export default RequestDetailedAdvanceFilter;

// Helper components
function RequestDetailsAdvanceFilterTabs({ state, handleChange }) {
  const tabs = ["Status", "File Moved"];
  const [currentActiveTab, setCurrentActiveTab] = useState(() => tabs[0]);
  const getNoOfAppliedFilter = (tab) => {
    if (tab === "Status") {
      const selectedStatusCount = Object.values(state.statusFilters).filter(
        Boolean
      ).length;
      return selectedStatusCount > 0 ? String(selectedStatusCount) : null;
    }
    if (tab === "File Moved") {
      const selectedFileMovedCount = Object.values(state.fileMoved).filter(
        Boolean
      ).length;
      return selectedFileMovedCount > 0 ? String(selectedFileMovedCount) : null;
    }

    return null;
  };
  return (
    <div className="request-details-advance-filter-tabs-container">
      <div className="request-details-advance-filter-tabs">
        {tabs.map((tab) => {
          const noOfAppliedFilter = getNoOfAppliedFilter(tab);
          return (
            <div
              key={tab}
              className={`request-details-advance-filter-tab ${
                currentActiveTab === tab
                  ? "request-details-advance-filter-tab-active"
                  : ""
              }`}
              onClick={() => setCurrentActiveTab(tab)}
            >
              <div>{tab} </div>
              <div
                className={classNames({
                  "filters-count": noOfAppliedFilter !== null,
                })}
              >
                {noOfAppliedFilter}
              </div>
            </div>
          );
        })}
      </div>
      <div className="request-details-advance-filter-tabs-section">
        {currentActiveTab === "Status" && (
          <div className="request-details-advance-filter-status-section">
            <FormControlLabel
              className="request-details-advance-filter-checkbox-select-all"
              control={
                <Checkbox
                  color="primary"
                  checked={Object.values(state.statusFilters).every(Boolean)}
                  indeterminate={
                    !Object.values(state.statusFilters).every(Boolean) &&
                    Object.values(state.statusFilters).some(Boolean)
                  }
                  onChange={() =>
                    handleChange("statusFilters", "selectAllStatus")
                  }
                />
              }
              label="Select all"
            />
            {["done", "pending", "cancelled", "expired"].map(
              (status, index) => (
                <FormControlLabel
                  key={status}
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.statusFilters[status]}
                      onChange={() => handleChange("statusFilters", status)}
                    />
                  }
                  label={capitalizeFirstLetter(status)}
                  className={index === 3 ? "" : "MuiFormControlLabel-root"}
                />
              )
            )}
          </div>
        )}
        {currentActiveTab === "File Moved" && (
          <div className="request-details-advance-filter-status-section">
            <FormControlLabel
              className="request-details-advance-filter-checkbox-select-all"
              control={
                <Checkbox
                  color="primary"
                  checked={Object.values(state.fileMoved).every(Boolean)}
                  indeterminate={
                    !Object.values(state.fileMoved).every(Boolean) &&
                    Object.values(state.fileMoved).some(Boolean)
                  }
                  onChange={() =>
                    handleChange("fileMoved", "selectAllFileMoved")
                  }
                />
              }
              label="Select all"
            />
            {["yes", "no"].map((movedStatus, index) => (
              <FormControlLabel
                key={movedStatus}
                control={
                  <Checkbox
                    color="primary"
                    checked={state.fileMoved[movedStatus]}
                    onChange={() => handleChange("fileMoved", movedStatus)}
                  />
                }
                label={capitalizeFirstLetter(movedStatus)}
                className={index === 3 ? "" : "MuiFormControlLabel-root"}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
